<template>
  <div class="home-box flex flex-d jc-sb">
    <div class="flex"><img class="logo" src="@/assets/logo.png"></div>
    <div class="centerWz flex flex-d jc-c">
      <div>上弦镜</div>
      <div>搜尽全球电商数据</div>
    </div>
    <div class="centerWzDown flex flex-d jc-c ai-c">
      <div>开发者：北京星图数网科技有限公司</div>
      <div>ios版本：V1.2.1 &nbsp;&nbsp; Android版本：V1.4.1</div>
      <div class="flex jc-c ai-c">
        <div class="goYs" @click="goQxlb">权限列表</div>
        <div class="goYs" @click="goYszc">隐私政策</div>
      </div>
      <div class="btnDiv" @click="goDownLoad">立即下载</div>
    </div>
    <Overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img class="logo" src="@/assets/goDown.png">
      </div>
      <div class="goDownTitle">1.点击右上角"..."</div>
      <div class="goDownTitle">2.选择"在浏览器中打开"</div>
    </Overlay>
  </div>
</template>

<script>
import { Overlay } from 'vant';
export default {
  name: 'carrousel',
  data() {
    return {
      show: false,
    }
  },
  components: {
    Overlay
  },
  mounted () {},
  computed: {},
  methods: {
    //打开新页面跳转权限列表
    goQxlb(){
      window.open("http://yinsidown.synlen.com/");
    },
    //打开新页面跳转隐私政策
    goYszc(){
      window.open("http://yinsi.synlen.com/");
    },
    //去下载
    goDownLoad(){
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isAndroid= u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      //u.toLowerCase().match(/MicroMessenger/i) == "micromessenger" //微信自带的浏览器打开
      if(isIos){
        //ios
        // console.log('ios浏览器')
        if(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"){
          //微信自带的浏览器打开
          this.show=true;
          // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
        }else{
          window.location.href = 'https://apps.apple.com/cn/app/id1601918648';
        }
      }else if(isAndroid){
        //安卓
        // console.log('安卓浏览器')
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.home-box {
  background: url("~@/assets/bg.png") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  .logo{
    width: 250px;
    margin: 40px;
  }
  .centerWz{
    width: 100%;
    color: #fff;
    font-size: 70px;
    font-family: "SourceHanSansCN-Medium, SourceHanSansCN";
    font-weight: 500;
    margin-top: -200px;
  }
  .centerWzDown{
    width: 100%;
    color: #fff;
    font-size: 28px;
    font-family: "SourceHanSansCN-Regular, SourceHanSansCN";
    font-weight: 400;
    padding-bottom: 80px;
    div{
      margin: 5px 0;
    }
    .goYs{
      cursor: pointer;
      margin: 0 10px;
      text-decoration:underline;
    }
    .btnDiv{
      width: 80%;
      height: 80px;
      line-height: 80px;
      border-radius: 40px;
      background-color: #1F95E2;
      color: #fff;
      font-size: 35px;
      font-weight: 600;
      margin-top: 50px;
    }
  }
}
//下载
.wrapper{
  text-align: right;
  padding: 0 10px;
}
.goDownTitle{
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 60px;
  padding: 0 30px;
}
/deep/ .van-overlay{
  background-color: rgba(0,0,0,.8);
}
@media screen and (min-device-width:1100px){
  .home-box{
    width: 260px !important;
    margin: 0 auto;
    padding: 18px;
    height: 100vh;
    box-sizing: border-box;
    .logo{
      width: 80px;
      margin: 10px;
    }
    .centerWz{
      width: 100%;
      color: #fff;
      font-size: 20px;
      font-family: "SourceHanSansCN-Medium, SourceHanSansCN";
      font-weight: 500;
      margin-top: 30px;
    }
    .centerWzDown{
      width: 100%;
      color: #fff;
      font-size: 10px;
      font-family: "SourceHanSansCN-Regular, SourceHanSansCN";
      font-weight: 400;
      padding-bottom: 20px;
      div{
        margin: 5px 0;
      }
      .goYs{
        cursor: pointer;
        margin: 0 10px;
        text-decoration:underline;
      }
      .btnDiv{
        width: 80%;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background-color: #1F95E2;
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        margin-top: 20px;
      }
    }
  }
  .wrapper{
    text-align: right;
    padding: 0 10px;
  }
  .goDownTitle{
    color: #fff;
    font-size: 20px;
  }
}
</style>